// @TODO find a better location for all these properties. Ilya S.
export enum TreeViewSize {
  IconsOnly = 0,
  Default = 1,
  Expanded = 2
}
